// Where the camera must stand to look straight at a point of a pitcher's developed surface,
// given as a share of its width (0 at the left edge, 1 at the right). The wall is a cylinder,
// so the share is a fraction of a turn; the offset is where the left edge of the texture sits
// on the model, measured on the GLB the preview uses.
const TURN_IN_RAD = Math.PI * 2;
const LEFT_EDGE_ANGLE_IN_RAD = 0;
const TURN_DIRECTION = 1;

function faceOrbitAngleInRad(shareOfSurfaceWidth: number): number {
    return LEFT_EDGE_ANGLE_IN_RAD + TURN_DIRECTION * shareOfSurfaceWidth * TURN_IN_RAD;
}

export { faceOrbitAngleInRad };
